import React from "react";
import Input from "../../../../../widget/common/form/Input";
import { RecoverPasswordContextImport } from "../../../../../provider/onboarding/forgot_password/recover_password/RecoverPasswordContextProvider";
import { CountryCodeList } from "../../../../../model/country_code/CountryCodeModel";
import PhoneNumber from "../../../../../widget/common/form/PhoneNumber";

export const RecoverPasswordEmailField = () => {
  const { handleOnChange, emailField, isFormValid } =
    RecoverPasswordContextImport();

  return (
    <Input
      type="email"
      name="email"
      handleOnChange={handleOnChange}
      value={emailField}
      label="email"
      validate={true}
      error={isFormValid}
    />
  );
};

export const RecoverPhoneField = () => {
  const {
    handleOnChange,
    phoneField,
    phoneCodeField,
    isFormValid,
    applyCountryCode,
  } = RecoverPasswordContextImport();

  const applyCode = (countryCodeDetail: CountryCodeList) => {
    applyCountryCode(countryCodeDetail);
  };

  return (
    <PhoneNumber
      name="phone_number"
      handleOnChange={handleOnChange}
      value={phoneField}
      code={phoneCodeField}
      label="phone_number"
      callback={applyCode}
      validate={true}
      error={isFormValid}
    />
  );
};
